import { determineIfScopeIsScan } from '../../helpers/scope';
import { Customer, GcpPlacementService, ScheduledFlight, Site } from '../../../../../types';
import { useUploadStore } from '../../../../../store/uploadStore';
import { substrDateFromAirtableFormat } from '../../helpers/date';
import { format } from 'date-fns';

export const useAreUploadsOverdue = (
  customer: Customer,
  site: Site,
  schedule?: ScheduledFlight,
  gcpPlacementService?: GcpPlacementService,
) => {
  const { getGcpRequest, getUpload } = useUploadStore();

  const date = schedule?.flightDateIso ?? gcpPlacementService?.servicesPerformedDateIso;

  if (!date || substrDateFromAirtableFormat(date) >= format(new Date(), 'yyyy-MM-dd')) {
    return {
      isScanOverdue: false,
      isPanoOverdue: false,
      isGcpOverdue: false,
    };
  }

  const scanUpload = getUpload(false, customer.id, site.id, schedule?.airtableRecordId);
  const panoUpload = getUpload(true, customer.id, site.id, schedule?.airtableRecordId);
  const gcpRequest = getGcpRequest(customer.id, site.id);

  const isScanOverdue = !!schedule && determineIfScopeIsScan(schedule.scope) && !scanUpload;
  const isPanoOverdue = !!schedule && !!site.projectInfo.parsedPanoramaLocations?.length && !panoUpload;
  const isGcpOverdue = !!gcpPlacementService && !gcpRequest?.measurements.length;

  return { isScanOverdue, isPanoOverdue, isGcpOverdue };
};
